import React from 'react';
import {connect} from 'react-redux'
import MaterialTable from 'material-table';
import {AgregarHabitacion,ModificarHabitacion} from '../../../Funciones/utils'
import {addRoom,modifyRoom} from '../../../graphql/mutations'

const CorroborarData=(data)=>{
    if (
    !data.number||
    !data.state){
      alert("Faltan completar campos")
      
      return false;
    }
    else{
        return true;
    }
}

 const MaterialTableDemo= ({data,setData,listaDeptos,dispatch,type,setLoading})=> {
   const lookup={ 1: 'ok',2: 'reparacion'}
   const columns= [
      { title: 'Nombre', field: 'room' },
      { title: 'Estado', field: 'state',lookup} ]
  const dictEstados={ 'ok': 1,'reparacion':2};
  return (
    <MaterialTable
      title={`Habitaciones (${listaDeptos.length})`}
      columns={columns}
      data={listaDeptos.map(x=>({...x,state:dictEstados[x.state]}))}
      style={{textAlign:"right !important",padding:'10px'}}
      localization={{
            body:{
            addTooltip:"Agregar habitacion",
            emptyDataSourceMessage:"No se cargaron habitaciones",
            deleteTooltip:"Eliminar",
            editTooltip:"Editar",
            editRow:{
            deleteText:"¿Seguro que quieres eliminar la habitacion?",
            cancelTooltip:"Cancelar",
            saveTooltip:"Guardar"}},
            header:{actions:"Acciones"}}}
      options={{
        search: false,
        sorting:false,
        draggable:false
      }}
      editable={{
        onRowAdd: newData =>{
            const room={number:newData.room,state:lookup[newData.state],type}
            if (CorroborarData(room))
            {
              AgregarHabitacion(room,setLoading,dispatch)
                
            }
           return( new Promise(resolve => {
                resolve();    
        }))},

        onRowUpdate: (newData, oldData) =>
        {
            const room={number:newData.room.toUpperCase(),state:lookup[newData.state],type}
            if (oldData&&CorroborarData(room)) 
            {
              room.roomId=listaDeptos.find(x=>x.room==oldData.room).roomId
              ModificarHabitacion(room,setLoading,dispatch)
              }
              return(new Promise(resolve => {
              resolve();
          }))},

        onRowDelete: oldData =>
          new Promise(resolve => {
              alert("No se pueden eliminar habitaciones debido a que pueden tener reservas y estas se perderian")
              resolve();
              setData(data.filter(x=>x!=oldData));

          }),
      }}
    />
  );
}

export default connect(state=>({}),null)(MaterialTableDemo)

